<template>
  <nav>
    <v-dialog v-model="dialog2" width="500px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" class="text-none" text stacked>
          <svg
            width="22"
            height="22"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 2.5V7.5M10 2.5V7.5M3.75 12.5H26.25M6.25 5H23.75C25.1307 5 26.25 6.11929 26.25 7.5V25C26.25 26.3807 25.1307 27.5 23.75 27.5H6.25C4.86929 27.5 3.75 26.3807 3.75 25V7.5C3.75 6.11929 4.86929 5 6.25 5Z"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span style="margin-left: 0.5rem; display: block">{{ periode }}</span>
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="text-h5">Ganti Periode</v-card-title>
        <br />
        <v-row justify="center">
          <v-date-picker v-model="picker" type="month" />
        </v-row>
        <v-card-actions>
          <v-spacer />
          <v-btn color="error" variant="text" @click="dialog2 = false">Batal</v-btn>
          <v-btn
            color="primary"
            variant="text"
            @click="
              dialog2 = false;
              gantiPeriode();
            "
            >Ya</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div style="display: flex; justify-content: space-between; gap: 1.5rem">
      <button style="color: white">
        <svg
          width="24"
          height="24"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 15C13.625 15 12.4479 14.5104 11.4688 13.5312C10.4896 12.5521 10 11.375 10 10C10 8.625 10.4896 7.44792 11.4688 6.46875C12.4479 5.48958 13.625 5 15 5C16.375 5 17.5521 5.48958 18.5312 6.46875C19.5104 7.44792 20 8.625 20 10C20 11.375 19.5104 12.5521 18.5312 13.5312C17.5521 14.5104 16.375 15 15 15ZM5 25V21.5C5 20.7917 5.18229 20.1406 5.54688 19.5469C5.91146 18.9531 6.39583 18.5 7 18.1875C8.29167 17.5417 9.60417 17.0573 10.9375 16.7344C12.2708 16.4115 13.625 16.25 15 16.25C16.375 16.25 17.7292 16.4115 19.0625 16.7344C20.3958 17.0573 21.7083 17.5417 23 18.1875C23.6042 18.5 24.0885 18.9531 24.4531 19.5469C24.8177 20.1406 25 20.7917 25 21.5V25H5ZM7.5 22.5H22.5V21.5C22.5 21.2708 22.4427 21.0625 22.3281 20.875C22.2135 20.6875 22.0625 20.5417 21.875 20.4375C20.75 19.875 19.6146 19.4531 18.4688 19.1719C17.3229 18.8906 16.1667 18.75 15 18.75C13.8333 18.75 12.6771 18.8906 11.5312 19.1719C10.3854 19.4531 9.25 19.875 8.125 20.4375C7.9375 20.5417 7.78646 20.6875 7.67188 20.875C7.55729 21.0625 7.5 21.2708 7.5 21.5V22.5ZM15 12.5C15.6875 12.5 16.276 12.2552 16.7656 11.7656C17.2552 11.276 17.5 10.6875 17.5 10C17.5 9.3125 17.2552 8.72396 16.7656 8.23438C16.276 7.74479 15.6875 7.5 15 7.5C14.3125 7.5 13.724 7.74479 13.2344 8.23438C12.7448 8.72396 12.5 9.3125 12.5 10C12.5 10.6875 12.7448 11.276 13.2344 11.7656C13.724 12.2552 14.3125 12.5 15 12.5Z"
            fill="#FEF7FF"
          />
        </svg>

        {{ user.getName() }}
      </button>
      <v-dialog v-model="dialog" width="auto">
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark v-bind="attrs" v-on="on" class="text-none" text stacked>
            <svg
              width="22"
              height="22"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.25 26.25H6.25C5.58696 26.25 4.95107 25.9866 4.48223 25.5178C4.01339 25.0489 3.75 24.413 3.75 23.75V6.25C3.75 5.58696 4.01339 4.95107 4.48223 4.48223C4.95107 4.01339 5.58696 3.75 6.25 3.75H11.25M20 21.25L26.25 15M26.25 15L20 8.75M26.25 15H11.25"
                stroke="#F5F5F5"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <span style="display: block; margin-left: 0.5rem">Keluar</span>
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="text-h5">Keluar</v-card-title>
          <v-card-text>Apakah anda yakin ingin keluar?</v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" variant="text" @click="dialog = false">Batal</v-btn>
            <v-btn
              color="error"
              variant="text"
              @click="
                dialog = false;
                logout();
              "
              >Ya</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </nav>
</template>

<style scoped>
nav {
  background-color: transparent;
  width: 100%;
  padding-left: 2rem !important;
  padding-right: 3rem;
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

button {
  display: flex;
  align-items: center;
  column-gap: 0.4rem;
  font-weight: bold;
  font-size: 0.8rem;
}

button svg {
  flex-shrink: 0;
}
</style>

<script>
import { User } from '@/libs/auth/user';
import axios from '@/libs/axios';
import Cookies from 'js-cookie';

export default {
  name: 'Nav',
  components: {},
  data() {
    return {
      dialog: false,
      dialog2: false,
      periode: '',
      picker: '',
      posting_dialog: false,
      posting_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).t,
      deposting_dialog: false,
      deposting_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).t,
      user: new User(),
    };
  },
  mounted() {
    this.loadBulanTahunLocalStorage();
  },
  methods: {
    async logout() {
      Cookies.remove('token');
      Cookies.remove('company_name');
      Cookies.remove('user_name');
      Cookies.remove('company_type');

      await this.$store.dispatch('auth_logout');
      await this.$router.push('/login');
    },
    async gantiPeriode() {
      let splitPicker = this.picker.split('-');

      localStorage.setItem('tahun', splitPicker?.[0]);
      let bulan = splitPicker?.[1];
      localStorage.setItem('bulan', bulan >= 10 ? bulan : bulan.replaceAll('0', ''));

      location.reload();
    },
    async loadBulanTahunLocalStorage() {
      const month = [
        'Januari',
        'Februari',
        'Maret',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Agustus',
        'September',
        'Oktober',
        'November',
        'Desember',
      ];
      const date = new Date();

      let bulan = localStorage.getItem('bulan');
      let tahun = localStorage.getItem('tahun');

      if (!bulan) {
        bulan = date.getMonth() + 1;
        localStorage.setItem('bulan', bulan);
      }

      if (!tahun) {
        tahun = date.getFullYear();
        localStorage.setItem('tahun', tahun);
      }

      this.periode = month[bulan - 1] + ' ' + tahun;

      this.picker = `${tahun}-${bulan.toString().padStart(2, '0')}-01`;
    },
    async posting() {
      try {
        const [year, month] = this.posting_date.split('-');

        await axios.post('/utility/posting', {
          month: parseInt(month),
          year: parseInt(year),
        });

        this.posting_dialog = false;

        alert('Posting successfuly !');
      } catch (error) {
        alert('Fail posting');
      }
    },
    async deposting() {
      try {
        const [year, month] = this.deposting_date.split('-');

        await axios.post('/utility/deposting', {
          month: parseInt(month),
          year: parseInt(year),
        });

        this.deposting_dialog = false;

        alert('Deposting successfuly !');
      } catch (error) {
        alert('Fail deposting');
      }
    },
  },
};
</script>
